import { Button } from "@mui/material";
import React, {useState, useEffect} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../components/container";
import DraftEditor from "../../components/DraftEditor";
import { deletePost, getPostById } from "../../services/api";

// Vista de detalle de una publicación
const PDetails: React.FC = () => {
    const [upd, setupd] = useState(false); // Controla la recarga de datos
    const [post, setpost] = useState<any>({}); // Guarda la publicación obtenida
    const [initialContent, setInitialContent] = useState<any>(undefined); // Guarda el contenido inicial para el editor
    const [updating, setUpdating] = useState(true); // Estado de actualización

    const {id}: any = useParams(); // Obtiene el id desde la ruta
    const navigate = useNavigate();

    useEffect(()=>{
        if(!upd && id){
            setupd(true);
            getPostById(id).then(v=>{
                if(v.data.successed){
                    setpost(v.data.post); // Guarda la publicación encontrada
                    setInitialContent(v.data.post.body) // Guarda el cuerpo de la publicación
                };
            });
        };
        if (post.id !== id) {
            setupd(false);
            setUpdating(true);
        };
    },[upd, id]);

    function delPost(){
        deletePost(id).then(v=>{
            if(v.data.successed){
                navigate("/") // Redirige al inicio después de eliminar
            };
        });
    };

    return(
        <MainContainer name="Comunicaciones" showHead title={
            <div className="mx-0">
                <Button variant="contained" className="mx-2" color="success"><Link className="stretched-link" to={`/editar/publicaciones/${id}`} />Editar</Button>
                <Button variant="contained" className="mx-2" color="error" onClick={delPost} >Eliminar</Button>
            </div>
        }>
            <div className="container mt-3">
                {initialContent && (
                    <DraftEditor disabled initialContent={initialContent} exportDataRaw={() => { }} onSavePost={()=>{}} />
                )}
            </div>
        </MainContainer>
    )
};

export default PDetails;